import React from 'react';
import styles from './DuplicateConfirmationModal.module.scss';

interface DuplicateConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
}

const DuplicateConfirmationModal: React.FC<DuplicateConfirmationModalProps> = ({ isOpen, onClose, onOpen }) => {
  if (!isOpen) return null;

  return (
    <div style={{display: isOpen ? 'block' : 'none'}}>
      <div className={styles.modalOverlay} onClick={onClose} />
      <div className={styles.optsWrapper}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
          </div>
          <div className={styles.modalBody}>
            <p>You already have an account with that email.</p>
          </div>
          <div className={styles.btnWrapper}>
            <button 
              onClick={onClose}
              style={{
                background: 'none',
                color: '#E64B37',
                fontSize: '20px',
                borderRadius: '10px',
                border: 'none'
              }}
            >
              <span>CANCEL SEND</span>
            </button>
          </div>
        </div>
      </div>

      <div className={styles.doneWrapper}>
        <button 
          onClick={onOpen}
          style={{
            background: 'none',
            color: '#4F7D9C',
            fontSize: '20px',
            margin: '5px',
            borderRadius: '10px',
            border: 'none'
          }}
        >
          See Duplicate Account
        </button>
      </div>
    </div>
  );
};

export default DuplicateConfirmationModal; 